import push from '../../utils/routing';

export default (spaceId) => () => push(`/dashboard/${spaceId}/people/groups`);
